import React, { useEffect, useState } from 'react';
import { collection, getDocs} from 'firebase/firestore';
import { db } from './firebase';
import { useAuth } from './AuthContext';
import { format } from 'date-fns';

const TIPO_LABELS = {
  ingreso:          { label: 'Ingreso',            badge: 'badge-green' },
  venta:            { label: 'Venta',              badge: 'badge-olive' },
  prestamo_salida:  { label: 'Préstamo (salida)',  badge: 'badge-yellow' },
  prestamo_entrada: { label: 'Préstamo (entrada)', badge: 'badge-gray' },
  devolucion:       { label: 'Devolución',         badge: 'badge-green' },
};

export default function Movimientos() {
  const { userData } = useAuth();
  const isAdmin = userData?.role === 'admin';
  const [movimientos, setMovimientos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tipoFiltro, setTipoFiltro] = useState('all');

  useEffect(() => {
    if (!userData?.uid) return;
    let cancelled = false;

    async function load() {
      try {
        // Cada embajadora ve solo sus movimientos
        // Sin orderBy para evitar problemas con documentos recién creados
        const snap = await getDocs(collection(db, 'movimientos'));
        if (cancelled) return;
        const rows = [];
        snap.forEach(d => {
          const m = { id: d.id, ...d.data() };
          if (!isAdmin && m.embajadoraId !== userData.uid) return;
          rows.push(m);
        });
        rows.sort((a, b) => {
          const fa = a.fecha?.toDate ? a.fecha.toDate() : new Date(a.fecha || 0);
          const fb = b.fecha?.toDate ? b.fecha.toDate() : new Date(b.fecha || 0);
          return fb - fa;
        });
        setMovimientos(rows);
      } catch (err) { console.error(err); }
      if (!cancelled) setLoading(false);
    }

    load();
    return () => { cancelled = true; };
  }, [userData, isAdmin]);

  const filtered = tipoFiltro === 'all'
    ? movimientos
    : movimientos.filter(m => m.tipo === tipoFiltro);

  return (
    <div>
      <div className="page-header">
        <h1>{isAdmin ? 'Movimientos' : 'Mis Movimientos'}</h1>
        <p>Historial de movimientos de stock</p>
      </div>
      <div className="page-body">
        <div className="toolbar">
          <select value={tipoFiltro} onChange={e => setTipoFiltro(e.target.value)}>
            <option value="all">Todos los tipos</option>
            {Object.entries(TIPO_LABELS).map(([k, v]) => (
              <option key={k} value={k}>{v.label}</option>
            ))}
          </select>
        </div>

        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          <div className="table-wrap">
            {loading ? <div className="spinner" /> : filtered.length === 0 ? (
              <div className="empty-state" style={{ padding: 40 }}>
                <div className="empty-state-icon">≡</div>
                <p>Sin movimientos registrados</p>
              </div>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Tipo</th>
                    {isAdmin && <th>Embajadora</th>}
                    <th>Producto</th>
                    <th>Aroma</th>
                    <th>Cantidad</th>
                    <th>Observación</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map(m => {
                    const tipo = TIPO_LABELS[m.tipo] || { label: m.tipo, badge: 'badge-gray' };
                    return (
                      <tr key={m.id}>
                        <td style={{ color: 'var(--text-light)' }}>
                          {m.fecha ? format(m.fecha.toDate ? m.fecha.toDate() : new Date(m.fecha), 'dd/MM/yy HH:mm') : '-'}
                        </td>
                        <td><span className={`badge ${tipo.badge}`}>{tipo.label}</span></td>
                        {isAdmin && <td>{m.embajadoraNombre}</td>}
                        <td style={{ fontWeight: 500 }}>{m.producto}</td>
                        <td style={{ color: 'var(--text-light)' }}>{m.aroma}</td>
                        <td style={{ fontWeight: 700, color: m.cantidad < 0 ? 'var(--alert-red)' : 'var(--alert-green)' }}>
                          {m.cantidad > 0 ? `+${m.cantidad}` : m.cantidad}
                        </td>
                        <td style={{ color: 'var(--text-light)', fontSize: 12 }}>{m.observacion || '-'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}